/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import React from 'react';
import { Popover, SvgCalendar } from '../../../utils';
import { LabeledInput } from '../../../LabeledInput';
import { DatePicker } from '../../../DatePicker';
import { IconButton } from '../../../Buttons';
const DatePickerInput = (props) => {
    const { onChange, date, parseInput, formatDate, ...rest } = props;
    const buttonRef = React.useRef(null);
    const [inputValue, setInputValue] = React.useState('');
    React.useEffect(() => {
        if (date && !isNaN(date.valueOf())) {
            setInputValue(formatDate(date));
        }
    }, [date, formatDate]);
    const [isVisible, setIsVisible] = React.useState(false);
    const close = React.useCallback(() => setIsVisible(false), []);
    const onDateSelected = React.useCallback((date) => {
        var _a;
        onChange(date);
        close();
        (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [close, onChange]);
    const onInputChange = React.useCallback((event) => {
        const value = event.target.value;
        setInputValue(value);
        if (!value) {
            onChange(undefined);
        }
        const parsedDate = parseInput(value);
        if (parsedDate && !isNaN(parsedDate.valueOf())) {
            onChange(parsedDate);
        }
    }, [onChange, parseInput]);
    return (React.createElement(Popover, { content: React.createElement(DatePicker, { date: date, onChange: onDateSelected, setFocus: true }), placement: 'bottom', visible: isVisible, onClickOutside: (_, e) => {
            var _a;
            if (!((_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
                close();
            }
        }, appendTo: 'parent' },
        React.createElement(LabeledInput, { displayStyle: 'inline', value: inputValue, onChange: onInputChange, onClick: close, svgIcon: React.createElement(IconButton, { styleType: 'borderless', onClick: () => setIsVisible((v) => !v), ref: buttonRef },
                React.createElement(SvgCalendar, null)), ...rest })));
};
export default DatePickerInput;
